import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { RestRoutes } from '../_config/rest-routes.config';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';
import { CacheConstants } from '../_config/cache-constants';
import { LanguageMessage } from '../_models/language-message.model.';
import { version } from 'js-base64';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  public languagesDownloaded$ = new Subject<{ [key: string]: any }>();
  public connectionError$ = new Subject<any>();

  constructor(
    private http: HttpClient,
    private storageService: StorageService,
  ) {}
  //versionLanguages: string = '';
  //public dictionary: any = null;

  GetLanguages(): Observable<any> {
    let urlLanguages: string = `${environment.urlWSLanguages}${RestRoutes.LANGUAGES}`;
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.get(urlLanguages, httpOptions);
  }

  async Languages_Get(): Promise<any> {
    let urlLanguageVersion: string = `${environment.urlWSLanguages}${RestRoutes.LANGUAGES}/version`;
    let versionData = await fetch(urlLanguageVersion)
      .then((response) =>
        response.json(),
      ).catch((error) => {
        this.connectionError$.next(error);
      });
    if (!versionData){
      return;
    }
    let cacheVersion = this.storageService.get(
      CacheConstants.LANGUAGE_CACHE_VERSION,
    );
    if (
      cacheVersion != null &&
      versionData['version'] == cacheVersion &&
      this.storageService.get(
        CacheConstants.LANGUAGE_CACHE_VERSION + '_' + cacheVersion,
      ) != null
    ) {
      let cacheDictionary = this.storageService.get(
        CacheConstants.LANGUAGE_CACHE_VERSION + '_' + cacheVersion,
      );
      this.languagesDownloaded$.next(cacheDictionary);
      return;
    }
    //this.storageService.remove(CacheConstants.LANGUAGE_CACHE_VERSION + '_' + cacheVersion);
    this.storageService.clearLanguageCache();

    cacheVersion = versionData['version'];
    //this.versionLanguages = versionData['version'];
    let urlLanguages: string = `${environment.urlWSLanguages}${RestRoutes.LANGUAGES}?v=${cacheVersion}`;
    await fetch(urlLanguages)
      .then((response) => response.json())
      .then((resJson) => {
        resJson = this.NormalizeDictionary(resJson);

        this.storageService.set(
          CacheConstants.LANGUAGE_CACHE_VERSION + '_' + cacheVersion,
          resJson,
        );
        this.storageService.set(
          CacheConstants.LANGUAGE_CACHE_VERSION,
          cacheVersion,
        );
        this.languagesDownloaded$.next(resJson);
      })
      .catch((error) => {
        console.log('language message');
        console.log(error);
      });
    return;
  }

  getLanguageMessage(
    key: string,
    culture: string,
  ): Observable<LanguageMessage> {
    let query = new URLSearchParams('culture=' + culture).toString();
    let urlCommerces = `${environment.urlWS}${RestRoutes.LANGUAGEMESSAGE}/${key}?${query}`;
    return this.http.get<LanguageMessage>(urlCommerces, this.httpOptions);
  }

  NormalizeDictionary(dictionary: { [key: string]: any }): {
    [key: string]: any;
  } {
    const normalizedResult: { [key: string]: any } = {};

    for (const culture in dictionary) {
      const translation = dictionary[culture];

      if (
        translation &&
        typeof translation === 'object' &&
        !Array.isArray(translation)
      ) {
        const normalizeTranslations: { [key: string]: any } = {};

        for (const key in translation) {
          if (translation[key]) {
            normalizeTranslations[key.trimEnd().toLowerCase()] = translation[key].trimEnd();
          }
        }

        normalizedResult[culture] = normalizeTranslations;
      } else {
        // Si no es un objeto (o es null), lo copiamos tal cual
        normalizedResult[culture] = translation;
      }
    }

    return normalizedResult;
  }
}
